import { useState } from "react";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AnimatedCol from "../../../../components/AnimatedCol";
import ContentExpansion from "../../../../components/ContentExpansion";
import Headline from "../../../../components/UI/Headline";
import HiddenWrapperRow from "../../../../components/UI/HiddenWrapperRow";
import MainArea from "../../../../components/UI/MainArea";
import { COMPRESSION_PILE, TENSION_PILE } from "../../../../constants.js";
import { selectLoadType, setFrontendState } from "../../../../store/slices/aashtoSlice";
import AreaOfGrout from "./AreaOfGrout";
import AxialCompressiveResistance from "./AxialCompressiveResistance";
import BarData from "./BarData";
import DesignCombination from "./DesignCombination.jsx";
import DesignCombinationDetails from "./DesignCombinationDetails";
import DesignLoad from "./DesignLoad";
import DraggableTableDrillbits from "./DraggableTableDrillbits";
import DrillBitDiameter from "./DrillBitDiameter";
import FactoredCompressionResistance from "./FactoredCompressionResistance.jsx";
import FactoredTensionResistance from "./FactoredTensionResistance.jsx";
import FactoredTensionResistanceHeaderText from "./FactoredTensionResistanceHeaderText.jsx";
import { FdCalc } from "./FdCalc";
import LoadType from "./LoadType.jsx";
import MeasurementTypeSelection from "./MeasurementTypeSelection";
import Rcu from "./Rcu";
import ResistanceFactorWithImage from "./ResistanceFactorWithImage";
import SelectedLoadCarryingElement from "./SelectedLoadCarryingElement.jsx";
import TwentyEightDayGroutStrength from "./TwentyEightDayGroutStrength.jsx";
import Utilization from "./Ultilization";

export default function Innere() {
  const { t } = useTranslation("translation");

  const loadType = useSelector(selectLoadType);
  const { calculatedDesignLoadCheckbox, showBarDataDetails } = useSelector(
    (state) => state.aashto.frontendState
  );

  const [showDesignCombinationDetails, setShowDesignCombinationDetails] = useState(false);
  const [showModal, setShowBohrkronenTable] = useState(false);

  return (
    <MainArea>
      <Headline isPrimary text={t("inner.headline")} />

      <div className="mt-5">
        <MeasurementTypeSelection />
        <LoadType />

        <Row>
          {loadType === COMPRESSION_PILE && <AxialCompressiveResistance />}
          {loadType === TENSION_PILE && <FactoredTensionResistanceHeaderText />}
        </Row>
        <br />
      </div>

      <div className="mt-5">
        <AnimatedCol>
          <Headline text={t("aashto.inner.Pd Calculation_pdf")} />
        </AnimatedCol>

        <AnimatedCol>
          <FdCalc />
        </AnimatedCol>

        {calculatedDesignLoadCheckbox && (
          <>
            <DesignCombination
              show={showDesignCombinationDetails}
              showModal={setShowDesignCombinationDetails}
            />
            <HiddenWrapperRow>
              <DesignCombinationDetails
                show={showDesignCombinationDetails}
                setShow={setShowDesignCombinationDetails}
              />
            </HiddenWrapperRow>
          </>
        )}

        <AnimatedCol>
          <DesignLoad />
        </AnimatedCol>

        <br />
      </div>

      <div className="mt-5">
        <ContentExpansion
          expand={showBarDataDetails}
          reducer={(val) => setFrontendState({ showBarDataDetails: val })}
        />
        <AnimatedCol>
          <Headline text={t("aashto.inner.Fd Verification of the load-bearing capacity")} />
        </AnimatedCol>
        <AnimatedCol>
          <SelectedLoadCarryingElement />
        </AnimatedCol>
        <Row>
          {/* HACK: 0px to keep the row small when the 'DraggableTableDrillbits' is visible */}
          <div className="col-md-4 offset-md-8" style={{ height: "0px" }}>
            <DraggableTableDrillbits show={showModal} setShow={setShowBohrkronenTable} />
          </div>
        </Row>
        <AnimatedCol>
          <BarData isVisible={showBarDataDetails} />
        </AnimatedCol>

        {loadType === COMPRESSION_PILE && (
          <AnimatedCol>
            <TwentyEightDayGroutStrength />
          </AnimatedCol>
        )}

        <AnimatedCol>
          <DrillBitDiameter showModal={setShowBohrkronenTable} />
        </AnimatedCol>

        {loadType === COMPRESSION_PILE && (
          <AnimatedCol>
            <AreaOfGrout />
          </AnimatedCol>
        )}

        <ResistanceFactorWithImage />

        {loadType === COMPRESSION_PILE ? (
          <>
            <AnimatedCol>
              <FactoredCompressionResistance />
            </AnimatedCol>
            <AnimatedCol>
              <Rcu />
            </AnimatedCol>
          </>
        ) : (
          <AnimatedCol>
            <FactoredTensionResistance />
          </AnimatedCol>
        )}
        <AnimatedCol>
          <Utilization />
        </AnimatedCol>
      </div>
    </MainArea>
  );
}
